import React, { useState, useEffect } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import Dashboard from '../../../../../layouts/Dashboard';
import EditArea from '../../../../../components/Global/Categories/Edit';

import { editCategoryInitQuery, Category } from './queries';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  organisation_id: string;
  category_id: string;
}

const EditAreaAdmin = ({ classes, history }: Props): React.ReactElement => {
  const { organisation_id, category_id } = useParams<UrlParams>();

  const [category, setCategory] = useState<Category>({
    name: '',
    organisation: {
      name: '',
    },
  });

  const { data: editCategoryInitData } = useQuery(editCategoryInitQuery(category_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && editCategoryInitData) {
      setCategory(editCategoryInitData.categories_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [editCategoryInitData]);

  const handleFinish = () => {
    history.push(`/admin/trusts/${organisation_id}/grouping`);
  };

  return (
    <>
      <Dashboard
        breadcrumbs={[
          { label: 'Trusts', link: '/admin/trusts' },
          { label: category.organisation.name, link: `/admin/trusts/${organisation_id}` },
          { label: 'Categoies', link: `/admin/trusts/${organisation_id}/grouping` },
          { label: category.name, link: `/admin/trusts/${organisation_id}/grouping` },
          { label: 'Edit' },
        ]}>
        <EditArea organisation_id={organisation_id} category_id={category_id} handleFinish={handleFinish} />
      </Dashboard>
    </>
  );
};

export default withRouter(withStyles(styles)(EditAreaAdmin));
